module.exports = __webpack_public_path__ + "img/laser-turret-gun-mask.f60fe701.png";